import { commonActions } from 'common/context/CommonSlice';
import { useAppDispatch } from 'common/context/hooks';
import { useFetch } from 'common/hooks/useFetchSwr';
import { AdminTablePaths } from 'common/model/AdminTablePaths';
import { useEffect } from 'react';

export const BrandManager = () => {
  const dispatch = useAppDispatch();

  const { data: brand, error } = useFetch<Brand>(AdminTablePaths.BRAND);

  useEffect(() => {
    if (brand) {
      dispatch(commonActions.setBrand(brand));
    }
  }, [brand, dispatch]);

  useEffect(() => {
    if (error?.response?.status === 404) {
      dispatch(commonActions.setRestorantCreating(true));
    }
  }, [dispatch, error]);

  return null;
};
